{
    "longSHA": "f8268c33de131249da088bcbc57641df88d5135e",
    "shortSHA": "f8268c3",
    "branch": "development",
    "authorName": "gasperc",
    "commitTime": "Fri Feb 20 14:12:53 2026 +0100",
    "commitMsg": "style: tabs to spaces",
    "totalCommitCount": "1"
}